import {
    GET_MACHINES,
    GET_MACHINE,
    ADD_MACHINE,
    UPDATE_MACHINE,
    DELETE_MACHINE,
    SET_LOADING_MACHINE,
    MACHINE_ERROR,
    SET_DELETE_MACHINE_ID,
    SET_UPDATE_MACHINE_ID,
    REMOVE_DELETE_MACHINE,
    REMOVE_UPDATE_MACHINE
} from '../actions/machine';

const initialState = {
    machines: [],
    machine: null,
    machine_options: [],
    firm_options: [],
    employee_options: [],
    loading: false,
    error: null,
    numberOfPages: 0,
    currentPage: 1,
    total_machines: 0,
    delete_machine_id: null,
    update_machine_id: null,
    update_machine: null
};

export default function machineReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_MACHINES:
            return {
                ...state,
                machines: payload.data || [],
                numberOfPages: payload.last_page || 0,
                currentPage: payload.current_page || 1,
                total_machines: payload.total || 0,
                loading: false,
                error: null
            };

        case GET_MACHINE:
            return {
                ...state,
                machine: payload,
                loading: false,
                error: null
            };

        case 'GET_MACHINE_OPTIONS':
            return {
                ...state,
                machine_options: payload.machines || payload.data || payload,
                loading: false,
                error: null
            };

        case ADD_MACHINE:
        case UPDATE_MACHINE:
        case DELETE_MACHINE:
            // These actions are no longer used since we refresh the list with getMachines()
            return state;

        case SET_LOADING_MACHINE:
            return {
                ...state,
                loading: payload
            };

        case MACHINE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };

        case SET_DELETE_MACHINE_ID:
            return {
                ...state,
                delete_machine_id: payload
            };

        case SET_UPDATE_MACHINE_ID:
            if (payload === null) {
                return {
                    ...state,
                    update_machine_id: null,
                    update_machine: null
                };
            }
            const machineToUpdate = state.machines.find(machine => machine.id === payload);
            return {
                ...state,
                update_machine_id: payload,
                update_machine: machineToUpdate
            };

        case REMOVE_DELETE_MACHINE:
            return {
                ...state,
                delete_machine_id: null
            };

        case REMOVE_UPDATE_MACHINE:
            return {
                ...state,
                update_machine_id: null,
                update_machine: null
            };

        case 'GET_FIRM_OPTIONS':
            return {
                ...state,
                firm_options: payload.data || payload
            };

        case 'GET_EMPLOYEE_OPTIONS':
            return {
                ...state,
                employee_options: payload.data || payload
            };

        case 'CLEAR_MACHINE_ERRORS':
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
} 